import * as ng from 'angular';
import * as nggt from 'angular-gettext';
import * as uir from '@uirouter/angularjs';
import * as _ from 'underscore';

import { MinAgeService } from '.';
import { LdaState, SiteConfig, Country, State } from '../shared';
import countries from '../shared/countries';
import { browserCountry } from '../shared/countries';
import { EventListService } from '../events';

resolveEventCountries.$inject = ['eventListService'];
export function resolveEventCountries(eventListService:EventListService) {
   return eventListService.getCountriesByName();
}

export class AgeGateController implements ng.IComponentController {
   static $inject = [
      '$window', '$interval', '$state', '$sce', '$interpolate', '$templateCache',
      'config', 'gettextCatalog', 'ldaState', 'minAgeService'
   ];

   constructor(
      private $window:ng.IWindowService,
      private $interval:ng.IIntervalService,
      private $state:uir.StateService,
      private $sce:ng.ISCEService,
      private $interpolate:ng.IInterpolateService,
      private $templateCache:ng.ITemplateCacheService,
      private config:SiteConfig,
      private gettextCatalog:nggt.gettextCatalog,
      private ldaState:LdaState,
      private minAgeService:MinAgeService
   ) {
      this.ageGateType = config.campaign.ageRequirementType;
   }

   readonly ageGateType:string;
   private isRedirecting:boolean = false;
   readonly countries = countries;
   country:Country;
   state:State;
   dob:string;
   eventCountries:any;

   include(templateId:string, scope:ng.IScope) {
      // using this to include html with translate-params- will stop working
      // with v2.4 of angular-gettext
      // https://github.com/rubenv/angular-gettext/issues/348#issuecomment-406164269
      return this.$interpolate(this.$templateCache.get(templateId))(scope).trim();
   }

   $onInit() {
      if (this.eventCountries) {
         this.country = _.findWhere(countries, {code: this.eventCountries.country});
      } else {
         this.country = _.findWhere(countries, {code: browserCountry()});
         if (!this.country) {
            this.country = _.findWhere(countries, {code: 'US'});
         }
      }
      this.state = this.country.states[0];
   }

   get minAge():number {
      return this.minAgeService.getMinAge(this.state, this.country);
   }

   get minAgeError() {
      return this.minAgeService.getMinAgeError();
   }

   get language() {
      return this.gettextCatalog.getCurrentLanguage();
   }

   get titleText() {
      return this.config.settings.ageGateTitle[this.language];
   }

   get countryTitle() {
      return this.config.settings.countryTitle[this.language];
   }

   get ageRequirementText() {
      let text = this.config.settings.ageRequirementText[this.language];
      if (text) {
         return this.$sce.trustAsHtml(text);
      }
   }

   get extraText() {
      let text = this.config.settings.ageGateText[this.language];
      if (text) {
         return this.$sce.trustAsHtml(text);
      }
   }

   get termsUrl() {
      if (this.config.settings.termsURL) {
         return this.config.settings.termsURL[this.language];
      }
   }

   get privacyUrl() {
      if (this.config.settings.privacyURL) {
         return this.config.settings.privacyURL[this.language];
      }
   }

   get cookiesUrl() {
      let url = this.$state.href('shell.cookies', {});
      if (this.config.settings.cookiesURL && this.config.settings.cookiesURL[this.language]) {
         url = this.config.settings.cookiesURL[this.language]
      }

      return url;
   }

   onContinue(form:ng.IFormController) {
      let ldaFailRedirect:string;
      if (this.config.settings.invalidAgeRedirect && this.config.settings.invalidAgeRedirect[this.language]) {
         ldaFailRedirect = this.config.settings.invalidAgeRedirect[this.language];
      }

      if (ldaFailRedirect && form.$error.minAge) {
         this.isRedirecting = true;

         // wait 4 seconds so that user sees the lda failure message
         this.$interval(() => {
            this.ldaState.redirect = true;
            this.$window.location.href = ldaFailRedirect;
         }, 4000, 1);
      }

      if (form.$valid && !this.isRedirecting) {
         this.ldaState.passed = true;

         this.$state.go('shell.events', {dob: this.dob});
      }
   }
}

ng.module('selfReg').component('ageGate', {
   templateUrl: require('./age-gate.html'),
   controller: AgeGateController,
   bindings: {
      eventCountries: '<'
   }
});
